export const SOUNDS_DIVISION_SELECTED = "488981__vinrax__melee_drop.mp3"
export const SOUNDS_MOVEMENT_ORDER_1 = "droze.mp3"; // DROZE!
export const SOUNDS_MOVEMENT_ORDER_2 = "chkara.mp3"; // DROZE!
export const SOUNDS_MOVEMENT_STEPS = "240732_stib_marching-concrete-loop (mp3cut.net).mp3" // "240732__stib__marching-concrete-loop.mp3";
export const SOUNDS_ATTACK_1 = ""; // SHETEVA, DAANGRIE
export const SOUNDS_ATTACK_2 = ""; // SHETEVA, DAANGRIE
export const SOUNDS_MELEE_1 = "486193__craigsmith__r21-07-men-yelling-while-fighting.wav"; // swords, ah oh
export const SOUNDS_MELEE_2 = "177084__mario1298__warriors-fighting-swords-shields.wav";
export const SOUNDS_MELEE_3 = "";

export const SOUNDS_DEATH_ENEMY = "enemy_defeated.mp3"; // AI, ESE MAGAT! DAVAMARTSXET
export const SOUNDS_DEATH_MY = "division_lost.mp3"; // EH, DAVKARGET DIVIZIA
export const SOUNDS_WIN = "";
export const SOUNDS_DEFEAT = "";

export const SOUNDS_INFANTRY = "";


export const playSound = (url, play=true, volume=1) => {
  try {
    if (!url)
      throw 1
    // var a = new Audio();
    if (!playingMap[url])
      loadSound(url)

    if (play) {
      playingMap[url].volume = volume
      playingMap[url].play()
    }
    else {
      playingMap[url].pause()
    }
    // new Audio(url).play()
  } catch (e) {
    console.log("failed on sound", url)
  }
}

const playingMap = {};
export const loadSound = url => {
  if (url)
    playingMap[url] = new Audio(url);
}

const audioUrls = [SOUNDS_DIVISION_SELECTED, SOUNDS_MELEE_1, SOUNDS_MELEE_2, SOUNDS_MOVEMENT_STEPS,
  SOUNDS_MOVEMENT_ORDER_1,
  SOUNDS_MOVEMENT_ORDER_2,
  SOUNDS_DEATH_ENEMY,
  SOUNDS_DEATH_MY
]

export const loadSounds = () => {
  audioUrls.forEach(au => {
    loadSound(au);
  })
}

loadSounds()
export const stopSounds = () => {
  try {
    audioUrls.forEach(au => {
      playSound(au, false)
    })

  } catch (e) {
    alert("error while stopping sounds")
  }
}
